/** Typed DOM helpers are shared across games; see @jpj/game-shell. */
import { $ } from "@jpj/game-shell";
export { $ } from "@jpj/game-shell";

/* Frequently used elements, cached once (module scripts run after parse). */
export const slotsEl = $("slots");
export const highlightEl = $("highlight");
export const piecesEl = $("pieces");
export const stageEl = $("stage");
export const trayEl = $("tray");
export const monEl = $("mon");
export const monStage = $("monStage");
